"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const rxjs_1 = require("rxjs");
var Cesium = window.Cesium;
/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
class Public3DRenderer extends _4d_mapper_1.Renderer {
    constructor(cesium) {
        super();
        this.cesium = cesium;
        if (!Cesium)
            Cesium = window['Cesium'];
        this._log();
    }
    onAdd(p, args) {
        this._log('onAdd', [p, args]);
        var sub = new rxjs_1.Subject();
        if (args && args.onInit) {
            args.onInit(p);
        }
        var c = new Cesium.Cesium3DTileset({
            url: p['url'],
            maximumScreenSpaceError: args && args.maximumScreenSpaceError ? args.maximumScreenSpaceError : (p['maximumScreenSpaceError'] || 2),
            maximumNumberOfLoadedTiles: 1000
        });
        if (args && args.onStart) {
            args.onStart(p, c);
        }
        if (c.tileFailed) {
            this.monitorEvent('tileFailed', c.tileFailed);
        }
        c.id = p.vertical_offset;
        var res = this.cesium.viewer.scene.primitives.add(c);
        c.transform_type = 'transform';
        c.transform_id = p.id;
        if (args && args.onProcess) {
            args.onProcess(p, res);
        }
        c.readyPromise.then(() => {
            if (args && args.onDuring) {
                args.onDuring(p, c);
            }
            var cartographic = null;
            if (c.pointCloudShading && p['pointCloudShading']) {
                Object.keys(p['pointCloudShading']).forEach(k => c.pointCloudShading[k] = p['pointCloudShading'][k] || c.pointCloudShading[k]);
            }
            if (p['shading']) {
                c.normalShading = false;
                c.style = new Cesium.Cesium3DTileStyle({
                    color: 'color("lightgray")'
                });
            }
            if (p.matrix && p.matrix.length == 16) {
                c.modelMatrix = Cesium.Matrix4.fromArray(p.matrix);
                cartographic = Cesium.Cartographic.fromCartesian(c.boundingSphere.center);
                var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0);
                var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, p.vertical_offset || 0);
                var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
                c.modelMatrix = Cesium.Matrix4.multiplyByTranslation(c.modelMatrix, translation, {});
            }
            else {
                cartographic = Cesium.Cartographic.fromCartesian(c.boundingSphere.center);
                var surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0);
                var offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, p.vertical_offset || 0);
                var translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
                c.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
            }
            // update the meta data of the dataset
            var plt = {
                plottable: p,
                object: c,
                boundingSphere: c.boundingSphere
            };
            if (!p.llng || p.llng == -180) {
                p.llng = Cesium.Math.toDegrees(cartographic.longitude) - 0.001;
                p.llat = Cesium.Math.toDegrees(cartographic.latitude) - 0.001;
                p.ulng = Cesium.Math.toDegrees(cartographic.longitude) + 0.001;
                p.ulat = Cesium.Math.toDegrees(cartographic.latitude) + 0.001;
                p.saveObservable().subscribe(_ => {
                    if (args && args.onEnd) {
                        args.onEnd(p, plt);
                    }
                    sub.next(plt);
                    sub.complete();
                });
            }
            else {
                if (args && args.onEnd) {
                    args.onEnd(p, plt);
                }
                sub.next(plt);
                sub.complete();
            }
        });
        return sub.asObservable();
    }
    onRemove(obj, pr) {
        this.cesium.viewer.scene.primitives.remove(pr.object);
        return rxjs_1.of(null);
    }
}
exports.Public3DRenderer = Public3DRenderer;
